export default "__VITE_ASSET__6RhKsSxp__"